import { trackPromise } from 'react-promise-tracker';
import { request } from './base';
import * as models from '../../models'; 
import utils from '../../utils'; 

export const createCopmany = async (payload: models.CreateCompanyRequest) => {
  const response = await request ({
    method: 'POST', 
    url: `/Companies`, 
    data: payload, 
  }); 
  return response; 
}; 

export const getCompanies = async (companiesRequest: models.CompaniesRequest) => {  
    var qStr = utils.helpers.encodeQueryString(companiesRequest); 
  
    const response = await request ({
      method: 'GET', 
      url: `/Companies?${qStr}`, 
    }); 
    return response; 
  }; 
  
  export const getCompanyByID = async (companyId: number) => {  
    const response = await request ({
      method: 'GET', 
      url: `/Companies/${companyId}`, 
    }); 
    return response; 
  }; 

  export const getCompaniesCSV = async (companiesRequest: models.CompaniesRequest) => {
      var qStr = utils.helpers.encodeQueryString(companiesRequest);     
      const response = await request ({
          method: 'GET',
          url: `/companies/export?${qStr}`, 
      });     
      if (response.isSuccess) {
          const responseData = await utils.filehelpers.readAsDataURL(new Blob([response.data], {type: "application/csv"}));
          try {
              utils.filehelpers.downloadFile(response);
  
          } catch (err) {
              return {
                  error: err,
                };
          }     
      return true; 
      }
      else {
          console.log(response); 
      }
  }

  export const updateCompany = async (companyId: number, payload: models.Company) => {
    return await request({
        method: 'PUT',
        url: `/companies/${companyId}`,
        data: payload,
    }); 
  }

 // company file types
  export const getCompanyFileTypes = async () => {
    return await request({
        method: 'GET',
        url: `/companyfiletypes`,
    }); 
  }

  export const addCompanyFileType = async (payload: models.AddCompanyFileType) => {
    return await request({
        method: 'POST',
        url: `/companyfiletypes`,
        data: payload  
    }); 
};

  export const updateCompanyFileType = async (payload: models.CompanyFileType) => {
    return await request({
        method: 'PUT',
        url: `/companyfiletypes/${payload.id}`,
        data: payload
    }); 
  }

  // company files
  export const getCompanyFiles = async (payload: models.CompanyFileRequest) => {
    var qStr = utils.helpers.encodeQueryString(payload); 
    return await request({
        method: 'GET',
        url: `/companies/${payload.companyId}/companyfiles?${qStr}`,
    });
  }

  export const uploadCompanyFile = async (payload: models.AddCompanyFile) => {    
    return await request({
        method: 'POST',
        url: `/companies/${payload.companyId}/companyfiles`,
        data: payload,
        headers: { 'Content-Type': 'multipart/form-data' }
    }); 
  }

  export const deleteCompanyFile = async (fileId: number, companyId: number) => {
    return await request({
        method: 'DELETE',
        url: `/companies/${companyId}/companyFiles/${fileId}`,
    }); 
  }

  export const getCompanyFile = async (compayId: number, id: number) => {
    return await request({
        method: 'GET',
        url: `/companies/${compayId}/companyFiles/${id}/download`,
        responseType: 'blob',
    }); 
  }; 

 export const getFileTypeSections = async (fileTypeId: number, companyId?: number | null) => {
    const params: Record<string, number> = {};
    if (companyId && companyId > 0) {
        params.companyId = companyId;
    }

    return await request({
        method: 'GET',
        url: `/companies/file-types/${fileTypeId}/sections`,
        params
    }); 
  }


  // dropdowns
  export const getAllCompaniesDD = async () => {
    return await request({
        method: 'GET',
        url: `/companies/dd/all`,
    }); 
  }

  export const getAgentCompanyDD = async () => {
    return await request({
        method: 'GET',
        url: `/companies/dd/agent`,
    }); 
  }

  export const getInsCompanyDD = async () => {
    return await request({
        method: 'GET',
        url: `/companies/dd/insurance`,
    }); 
  }

  export const getMortgageCompanyDD = async () => {
    return await request({
        method: 'GET',
        url: `/companies/dd/mortgage`,
    }); 
  }

  export const getCompanyFileTypesDD = async () => {
    return await request({
        method: 'GET',
        url: `/companyfiletypes/dd`,
    }); 
  }